import React, { ComponentType } from 'react';
import { SelectValue } from 'antd/lib/select';
import { Select as AntSelect, SelectProps } from 'antd';
import * as S from './styles';

const { Option } = AntSelect;

export type OptionType = Array<
  | string
  | {
      value: string | undefined;
      text: React.ReactNode | string;
      disabled?: boolean | undefined | null;
    }
>;

type Props = {
  option?: OptionType;
} & SelectProps<SelectValue>;

export const Select = function ({ children, ...props }: Props) {
  // In version https://ant.design/changelog#4.18.0 antdesign introduced a breaking change
  // https://github.com/ant-design/ant-design/pull/33364
  // messing up type definition for Select to make it more generic
  // cannot be used along with styled-components
  const HackedSelect = S.Select as ComponentType<SelectProps<SelectValue>>;
  return (
    <HackedSelect suffixIcon={<S.DropDownIcon />} {...props}>
      {props.option?.map(valueOrObject => {
        return (
          <Option
            value={
              typeof valueOrObject === 'string'
                ? valueOrObject
                : (valueOrObject.value as string)
            }
            key={
              typeof valueOrObject === 'string'
                ? valueOrObject
                : valueOrObject.value
            }
            disabled={
              typeof valueOrObject === 'string' ? false : valueOrObject.disabled
            }
          >
            {typeof valueOrObject === 'string'
              ? valueOrObject
              : valueOrObject.text}
          </Option>
        );
      })}
    </HackedSelect>
  );
};
